import { render } from "./GetNotifiedView.vue?vue&type=template&id=556e6001"
import script from "./GetNotifiedView.vue?vue&type=script&lang=js"
export * from "./GetNotifiedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__